import React from 'react'
import firebase from "firebase";
import FileUploader from "react-firebase-file-uploader";

import { TableRow, TableCell, Typography } from '@material-ui/core';

const CompUpload = (props) => {

    const [avatar, setAvatar] = React.useState("");
    const [isUploading, setIsUploading] = React.useState(false);
    const [progress, setProgress] = React.useState(0);
    const [avatarURL, setAvatarURL] = React.useState("");


    const handleUploadStart = () => {
        setIsUploading(true)
        setProgress(0)
    }
    const handleProgress = (progress) => {
        setProgress(progress);
    }

    const handleUploadError = error => {
        setIsUploading(false);
        console.error(error);
    };
    const handleUploadSuccess = filename => {
        setAvatar(filename);
        setProgress(100);
        setIsUploading(false);
        firebase
            .storage()
            .ref("images")
            .child(filename)
            .getDownloadURL()
            .then(function (downloadURL) {
                props.setPracticaURL(downloadURL);
            });
    };

    return (
        <React.Fragment>
        <TableRow >
            <TableCell align='justify'>
            <form>
                {isUploading && <Typography >Subiendo: {progress}</Typography>}
                {avatarURL && <img src={avatarURL} />}
                <FileUploader
                    accept="image/*"
                    name="avatar"
                    randomizeFilename
                    storageRef={firebase.storage().ref("images")}
                    onUploadStart={handleUploadStart}
                    onUploadError={handleUploadError}
                    onUploadSuccess={handleUploadSuccess}
                    onProgress={handleProgress}
                />
            </form>
            </TableCell>
            </TableRow>
        </React.Fragment>
    )
}

export default CompUpload
